<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-13 11:24:47
 * @LastEditTime: 2023-02-02 17:25:25
 * @Description:
 * @FilePath: \com.tudouec.manager.pm.vue.v1d:\codeLibraty\金豆\中国薯网官网\web\website\src\components\Topic.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="topic-bg" :style="{ 'background-image': `url(${topicBg})` }">
    <LoadMore
      v-if="showMore"
      :color="color"
      :arrow="arrow"
      :arrowColor="arrowColor"
      :pagename="pagename"
    ></LoadMore>
  </div>
</template>
<script>
export default {
  name: "Topic",
  props: {
    topicBg: String,
    showMore: { type: Boolean, default: false },
    color: { type: String, default: "#686B82" },
    arrow: { type: String, default: "right" },
    arrowColor: { type: String, default: "#019845" },
    pagename: { type: String, default: "" },
  },
  data() {
    return {};
  },
  mounted: [],
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/.topic-bg {
  height: 60px;
  background-size: cover;
  display: flex;
  justify-content: end;
  align-items: center;
  margin-bottom: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Topic.vue